// ================= MAKE: units (everything is stored in mm) =================
let UNIT='mm';const UF={mm:1,in:25.4,m:1000};
const ul=()=>UNIT, U=()=>UF[UNIT];
function fd(mm){if(mm==null||!isFinite(mm))return '';const d=UNIT==='mm'?2:UNIT==='in'?3:4,p=10**d;return String(Math.round(mm/UF[UNIT]*p)/p)}
function fdIn(mm){if(mm==null||!isFinite(mm))return '';const d=UNIT==='mm'?3:UNIT==='in'?4:5,p=10**d;return String(Math.round(mm/UF[UNIT]*p)/p)}
const lenIn=v=>{const n=num(v);return n==null?null:n*UF[UNIT]};
const isLenK=k=>!['n','z','m'].includes(k);
